import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { message } from "antd"

type Props = {
    text: Maybe<string>
    type: Maybe<AutoCloseMessageType>
}

export const AutoCloseMessageTypeEnum = {
    Success: "success",
    Error: "error",
    Warning: "processing",
    Info: "info",
}

export type AutoCloseMessageType = (typeof AutoCloseMessageTypeEnum)[keyof typeof AutoCloseMessageTypeEnum]

export const AutoCloseMessageComponent = (props: Props) => {
    const { type, text } = props

    if (!type || !text) {
        return null
    }

    const error = (s: string) => message.error(s)

    const warning = (s: string) => message.warning(s)

    const success = (s: string) => message.success(s)

    const info = (s: string) => message.info(s)

    switch (type) {
        case AutoCloseMessageTypeEnum.Success:
            return success(text)

        case AutoCloseMessageTypeEnum.Warning:
            return warning(text)

        case AutoCloseMessageTypeEnum.Error:
            return error(text)

        case AutoCloseMessageTypeEnum.Info:
            return info(text)

        default:
            return null
    }
}
